export default __webpack_public_path__ + "static/media/south.e98350a7.png";